import { Subscript } from '@mui/icons-material';
import apiService from './apiService';
import { getToken } from './authService';

const LeadService = {
    searchLeads: async (storeData, currentPage) => {
        const { isa_search, status_search, customer_name, customer_phone, agent_search, created_at } = storeData;
        try {
            let queryParams = '';
            if (currentPage) {
                queryParams += `?page=${currentPage}`;
            }
            if (isa_search) {
                queryParams += `&isa_search=${isa_search}`;
            }
            if (status_search) {
                queryParams += `&status_search=${status_search}`;
            }
            if (customer_name) {
                queryParams += `&customer_name=${customer_name}`;
            }
            if (customer_phone) {
                queryParams += `&customer_phone=${customer_phone}`;
            }
            if (agent_search) {
                queryParams += `&agent_search=${agent_search}`;
            }
            if (created_at) {
                queryParams += `&created_at=${created_at}`;
            }
            const response = await apiService.get(`/search-leads${queryParams}`);
            // const response = await apiService.get(`/search-leads`, { params: storeData });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },

    getallIsa: async () => {
        try {
            const response = await apiService.get(`/get-all-isa`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    AllLeadByAdmin: async (currentPage, searchTerm, filters, searchParam, IsSearchType) => {
        try {
            const { source, lead_type, status } = filters;
            const { from_date, to_date, search_type } = searchParam;

            let queryParams = `?page=${currentPage}`;

            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }

            if (source) {
                queryParams += `&source=${source}`;
            }

            if (lead_type) {
                queryParams += `&lead_type=${lead_type}`;
            }

            if (status) {
                queryParams += `&status=${status}`;
            }

            if (from_date) {
                queryParams += `&from_date=${from_date}`;
            }

            if (to_date) {
                queryParams += `&to_date=${to_date}`;
            }
            if (search_type) {
                queryParams += `&search_type=${search_type}`;
            }
            if (IsSearchType) {
                queryParams += `&search_type=${IsSearchType}`;
            }

            const response = await apiService.get(`/getAllLeadByAdmin${queryParams}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    InvitedLeadByAdmin: async (currentPage, searchTerm, status) => {
        try {
            let queryParams = `?page=${currentPage}`;

            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }

            if (status) {
                queryParams += `&status=${status}`;
            }

            const response = await apiService.get(`/getAllLeadByAdmin${queryParams}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getIsaChat: async (chatId) => {
        try {
            const response = await apiService.post(`/get-isa-chat`, { id: chatId });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    leadDetailsByAdmin: async (id) => {
        try {
            const response = await apiService.post(`leadDetailsByAdmin`, { lead_id: id });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    changeAgentStatus: async (id, newStatus) => {
        try {
            const response = await apiService.post(`changeAgentMode`, { id: id, offline_mode: newStatus });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    HandlePauseUnpauseAgent: async (id, newStatus) => {
        try {
            const response = await apiService.post(`pauseUnpauseAgent`, { user_id: id, pause: newStatus });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    organizationAgentToSelf: async (moveToSelf) => {
        try {
            const response = await apiService.post(`organizationAgentToSelf`, { id: moveToSelf });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    pauseUnpauseCustomer: async (id, newStatus) => {
        try {
            const response = await apiService.post(`pauseUnpauseCustomer`, { user_id: id, pause: newStatus });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    EmailToAgents: async (selectedIds) => {
        try {
            const response = await apiService.post(`/sendEmailToAgents`, { id: selectedIds });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    addIsainternalchat: async (data) => {
        try {
            const response = await apiService.post(`/add-ISAagent-internal-chat`, { ...data });
            return response;
        } catch (error) {
            throw new Error(`Failed to fetch user assign leads: ${error.message}`);
        }
    },
    getIsaAgents: async (currentPage, searchTerm, selectedOrganization) => {
        try {
            let queryParams = `?page=${currentPage}`;
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            if (selectedOrganization) {
                queryParams += `&organization=${selectedOrganization}`;
            }

            const response = await apiService.get(`/admin-get-isa-agents${queryParams}`);
            // const response = await apiService.get(`/admin-get-isa-agents?page=${currentPage}&search=${searchTerm}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getAdminLeadsApi: async (filters) => {
        try {
            const response = await apiService.get(`/getAllLeadByAdmin`, {
                params: {
                    ...filters,
                },
            });
            return response;
        } catch (error) {
            throw new Error(`Failed to fetch admin leads: ${error.message}`);
        }
    },
    icaLeads: async (currentPage, selectedFilterValue) => {
        try {
            let queryParams = `?page=${currentPage}`;
            if (selectedFilterValue) {
                queryParams += `&filter=${selectedFilterValue}`;
            }
            const response = await apiService.get(`/getSendIsaAgentLeads${queryParams}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getLeads: async (searchValue,currentPage) => {
        try {
            const response = await apiService.get(`/get-leads?search=${searchValue}&page=${currentPage}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },

    getAgentsApi: async (
        currentPage,
        searchTerm,
        selectedValue,
        selectedFilterValue,
        selectedLocation,
        selectedOrganization,
        selectedRefer,
        isPaginated,
        signal,
        fromDate = '', // Add fromDate
        toDate = '', // Add toDate
        SubscriptionDevice,
        CommaSeparateSelectedTagsIds,
    ) => {
        try {
            let queryParams = `?page=${currentPage}`;
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            if (selectedValue) {
                queryParams += `&sortBy=${selectedValue}`;
            }
            if (selectedFilterValue) {
                queryParams += `&filter_by=${selectedFilterValue}`;
            }

            if (selectedLocation) {
                queryParams += `&prefered_location=${selectedLocation}`;
            }
            if (selectedOrganization) {
                queryParams += `&organization=${selectedOrganization}`;
            }
            if (selectedRefer) {
                queryParams += `&refer_by=${selectedRefer}`;
            }
            if (isPaginated) {
                queryParams += `&isPaginated=${isPaginated}`;
            }
            if (fromDate) {
                // Add fromDate if provided
                queryParams += `&from_date=${fromDate}`;
            }
            if (toDate) {
                // Add toDate if provided
                queryParams += `&to_date=${toDate}`;
            }
            if (SubscriptionDevice) {
                // Add toDate if provided
                queryParams += `&subscription_type=${SubscriptionDevice}`;
            }
            if (CommaSeparateSelectedTagsIds) {
                // Add toDate if provided
                queryParams += `&tags=${CommaSeparateSelectedTagsIds}`;
            }
            const response = await apiService.get(`/admin-get-agents${queryParams}`);
            // const response = await apiService.get(`/admin-get-agents?page=${currentPage}&search=${searchTerm}&sortBy=${selectedValue}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },

    getAgentsApiRefDetails: async (ref,currentPage) => {
        try {
            let queryParams = `?refer_by=${ref}`;
            if(currentPage) {
                queryParams += `&page=${currentPage}`;
            }
            const response = await apiService.get(`/admin-get-agents${queryParams}`);
            // const response = await apiService.get(`/admin-get-agents?page=${currentPage}&search=${searchTerm}&sortBy=${selectedValue}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },

    AgentInvite: async (selectedPropertyId) => {
        try {
            const response = await apiService.get(`/getAgentInvite?lead_id=${selectedPropertyId}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    icaAgentAssignLead: async (selectedAgentId) => {
        try {
            const response = await apiService.post('/icaAgentAssignLead', { assign_id: selectedAgentId });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },

    getIsaAgentDetailsApi: async (id) => {
        try {
            const response = await apiService.post('/admin-get-isa-agents-details', { id: id });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },

    getICAAAgentAssignmentApi: async (id, currentPage, searchTerm, filters, searchParam) => {
        try {
            const { status } = filters;
            const { from_date, to_date } = searchParam;
            let queryParams = `?id=${id}&page=${currentPage}`;
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            if (status) {
                queryParams += `&status=${status}`;
            }
            if (from_date) {
                queryParams += `&from_date=${from_date}`;
            }

            if (to_date) {
                queryParams += `&to_date=${to_date}`;
            }

            const response = await apiService.get(`/admin-get-isa-agents-assignments${queryParams}`);

            // const response = await apiService.get(`/admin-get-isa-agents-assignments?id=${id}&page=${currentPage}&search=${searchTerm}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    nearestAgents: async (selectedLocation, selectedPropertiesId, formattedSelectTime, selectedDate, radius,selectedTags) => {
        
        try {
            const response = await apiService.post('/nearestAgents', {
                lead_id: selectedPropertiesId,
                prefered_location: selectedLocation,
                time: formattedSelectTime,
                date: selectedDate,
                radius: radius,
                tags: selectedTags,
            });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    AssignLeadsToAgents: async (AssignAgentData, selectedPropertiesId, selectedDate, formattedSelectTime, googleLocation, latitude, longitude) => {
        try {
            const response = await apiService.post('/sendLeadsToAgents', {
                lead_id: selectedPropertiesId,
                user_id: AssignAgentData,
                date: selectedDate,
                time: formattedSelectTime,
                meeting_location: googleLocation,
                meeting_latitude: latitude,
                meeting_longitude: longitude,
            });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    icaAgentInternalNote: async (selectedPropertiesId, note, timestamp) => {
        try {
            const response = await apiService.post('/addICAAgentInternalNote', { id: selectedPropertiesId, note: note, timestamp: timestamp });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    GetLeadNote: async (LeadId) => {
        
        try {
            const response = await apiService.get(`/getLeadNotes?lead_id=${LeadId}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    updateStatus: async (updateStatusValue, Lead_id, LoginUserId) => {
        try {
            const response = await apiService.post('/update-status', { id: LoginUserId, status: updateStatusValue, lead_id: Lead_id });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getLeadDetails: async (LeadId) => {
        try {
            const response = await apiService.post('/lead-details', { lead_id: LeadId });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    GetAgentProfileDetail: async (agentId) => {
        try {
            const response = await apiService.post('/agentProfileDetail', { id: agentId });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getAgentLatestResponseApi: async () => {
        try {
            const response = await apiService.get('/getAgentLatestResponse');
            return response;
        } catch (error) {
            throw new Error(`Failed to get ISA agent leads: ${error.message}`);
        }
    },
    getLeadSearchDataApi: async () => {
        try {
            const response = await apiService.get('/getLeadSearchData');
            return response;
        } catch (error) {
            throw new Error(`Failed to get ISA agent leads: ${error.message}`);
        }
    },

    agentRegisterByAdminApi: async (values) => {
        const formData = new FormData();
        formData.append('name', values.name);
        formData.append('email', values.email);
        formData.append('password', values.password);
        formData.append('last_name', values.last_name);
        formData.append('phone', values.phone);
        formData.append('prefered_location', values.prefered_location);
        formData.append('password', values.password);
        formData.append('profile_image', values.image);
        try {
            const response = await apiService.post('/agentRegisterByAdmin', formData);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },

    isaAgentRegisterByAdminApi: async (values) => {
        const formData = new FormData();
        formData.append('name', values.name);
        formData.append('last_name', values.last_name);
        formData.append('phone', values.phone);
        formData.append('email', values.email);
        formData.append('password', values.password);
        // formData.append('prefered_location', values.prefered_location);
        formData.append('profile_image', values.image);
        try {
            const response = await apiService.post('/isaagentRegisterByAdmin', formData);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    UpdateIcaAgent: async (values) => {
        const formData = new FormData();
    
        // Helper to append only defined and non-null values
        const appendIfValid = (key, value) => {
            if (value !== undefined && value !== null && value !== '') {
                formData.append(key, value);
            }
        };
    
        // Dynamically append form data
        appendIfValid('user_id', values.id);
        appendIfValid('name', values.name);
        appendIfValid('last_name', values.last_name);
        appendIfValid('phone', values.phone);
        appendIfValid('cover_video', values.cover_video);
        appendIfValid('profile_url', values?.profile_url);
        appendIfValid('email', values.email);
        appendIfValid('bio', values?.bio);
        appendIfValid('password', values.password?.trim() || null);
        appendIfValid('preferred_location', values?.prefered_location);
    
        // Handle file separately
        if (values.image instanceof File) {
            appendIfValid('profile_image', values.image);
        }
    
        try {
            const response = await apiService.post('/updateAgentandICAByAdmin', formData);
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message || 'An error occurred while updating the agent.');
        }
    },
    ICAProfile: async () => {
        try {
            const response = await apiService.get(`/getICAProfile`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    runCronJob: async () => {
        try {
            const response = await apiService.get(`/runCronJob`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    editICAProfile: async (values) => {
        try {
            const formData = new FormData();
            formData.append('name', values.name);
            formData.append('email', values.email);
            formData.append('profile_image', values.selectedImage);
            formData.append('last_name', values.last_name);
            formData.append('phone', values.phone);
            formData.append('bio', values.bio);
            const response = await apiService.post('/editICAProfile', formData);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    AllUsersSearchAdmin: async () => {
        try {
            const response = await apiService.get(`/getAllUsers`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    StatusesOverview: async (SearchParam) => {
        try {
            const response = await apiService.get(`/getStatusesOverview`, { params: SearchParam });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    GetLeadsCountByStatus: async (id) => {
        try {
            let response;
            if(id){
                response = await apiService.get(`/leadsCountByStatus?id=${id}`);
            }else{
                response = await apiService.get(`/leadsCountByStatus`);
            }
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    GetLeadsCountByStatusDashboard: async (formattedDate) => {
        
        try {
            let response;
            if(formattedDate === "Invalid Date"){
                response = await apiService.get(`/leadsCountByStatus`);
            }else{
                response = await apiService.get(`/leadsCountByStatus?yearMonth=${formattedDate}`);
            }
            
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    TotalAllCountData: async () => {
        try {
            const response = await apiService.get(`/countData`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getChatAdmin: async (currentPage, searchTerm, LeadsDetailId) => {
        try {
            let queryParams = `?page=${currentPage}`;

            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }

            if (LeadsDetailId) {
                queryParams += `&lead_id=${LeadsDetailId}`;
            }
            const response = await apiService.get(`/getAllChatByAdmin${queryParams}`);
            //    const response = await apiService.get(`/getAllChatByAdmin?page=${currentPage}&search=${searchTerm}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getChatAdminDetails: async (id) => {
        try {
            const response = await apiService.post('/getChatByadmin', { id: id });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getServices: async () => {
        try {
            const response = await apiService.get(`/services`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getLocation: async ({ currentPage, searchTerm, isPaginated,organization_id }) => {
        try {
            let queryParams = '';
            if (currentPage) {
                queryParams += `?page=${currentPage}`;
            }
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            if (isPaginated) {
                queryParams += `&isPaginated=${isPaginated}`;
            }
            if (organization_id) {
                queryParams += `&organization_id=${organization_id}`;
            }
            const response = await apiService.get(`/getAllPreferedRegions${queryParams}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },

    getLocationForAgent: async (currentPage, searchTerm, isPaginated) => {
        try {
            let queryParams = '';
            if (currentPage) {
                queryParams += `?page=${currentPage}`;
            }
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            if (isPaginated) {
                queryParams += `&isPaginated=${isPaginated}`;
            }
            const response = await apiService.get(`/getAllPreferedRegions${queryParams}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },

    getOrganizations: async () => {
        try {
            const response = await apiService.get(`/organizations`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    AddServices: async (serviceName, servicePrice) => {
        try {
            const response = await apiService.post('/addservice', { service_name: serviceName, price: servicePrice });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    AddPreferredLocation: async (preferredLocation, latitudeFloat, longitudeFloat, angleFloat,selectedOrganization) => {
        try {
            const response = await apiService.post('/createPreferedRegions', {
                region_name: preferredLocation,
                latitude: latitudeFloat,
                longitude: longitudeFloat,
                radius: angleFloat,
                organization_id: selectedOrganization,
            });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    deleteServices: async (deleteId) => {
        try {
            const response = await apiService.get(`/deleteService/${deleteId}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    updatedService: async (ServiceId, serviceName, servicePrice) => {
        try {
            const response = await apiService.post(`/updateService`, { id: ServiceId, service_name: serviceName, price: servicePrice });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    updatedLocation: async (locationId, preferredLocation, latitude, longitude, angle,selectedOrganization) => {
        try {
            const response = await apiService.post(`/updatePreferedRegion`, {
                id: locationId,
                region_name: preferredLocation,
                latitude: latitude,
                longitude: longitude,
                radius: angle,
                organization_id: selectedOrganization,
            });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    deleteLocation: async (deleteId) => {
        try {
            const response = await apiService.get(`/deletePreferedRegion/${deleteId}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },

    getJobs: async (currentPage, searchTerm, selectedValue) => {
        try {
            let queryParams = `?page=${currentPage}`;
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            if (selectedValue) {
                queryParams += `&job_type=${selectedValue}`;
            }

            const response = await apiService.get(`/GetAllJobsByAdmin${queryParams}`);

            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },

    MonthlyJobCounts: async (JobType) => {
        try {
            const response = await apiService.get(`/getMonthlyJobCounts?job_type=${JobType}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    jobDetail: async (id, job_type) => {
        try {
            const response = await apiService.post(`/jobDetailByAdmin`, { job_id: id, job_type: job_type });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    AllCities: async () => {
        try {
            const response = await apiService.get(`/getCities`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    GetScheduling: async (searchTerm, selectedValue, selectedJobValue, filters) => {
        try {
            const { status } = filters;
            let queryParams = `?search=${searchTerm}`;

            if (selectedValue) {
                queryParams += `&type=${selectedValue}`;
            }
            if (selectedJobValue) {
                queryParams += `&job_filter=${selectedJobValue}`;
            }
            if (status) {
                queryParams += `&lead_filter=${status}`;
            }

            const response = await apiService.get(`/AdminGetSchedule${queryParams}`);
            // const response = await apiService.get(`/AdminGetSchedule`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getAllJobRoutes: async (hours, dateTime, city, currentPage) => {
        try {
            const response = await apiService.post(`/AdminGetAllJobRoutes?page=${currentPage}`, { hours: hours, date_time: dateTime, city: city });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getAdminNotifications: async (selectedValue, selectedAlertValue) => {
        try {
            let queryParams = `?type=${selectedAlertValue}`;

            if (selectedValue) {
                queryParams += `&time=${selectedValue}`;
            }
            const response = await apiService.get(`/getAdminNotifications${queryParams}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getIcaAlerts: async (selectedValue, selectedAlertValue) => {
        try {
            let queryParams = `?type=${selectedAlertValue}`;

            if (selectedValue) {
                queryParams += `&time=${selectedValue}`;
            }
            const response = await apiService.get(`/getIcaAlerts${queryParams}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    importPreferedRegion: async (csvFile) => {
        const formData = new FormData();
        formData.append('csv_file', csvFile);
        try {
            const response = await apiService.post('/importPreferedRegions', formData);
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message || 'Failed to import preferred regions.');
        }
    },

    getAllOrganization: async () => {
        try {
            const response = await apiService.get(`/organizations`);
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },
    getOrganizationByID: async (LoginUserID) => {
        try {
            const response = await apiService.get(`/organization/${LoginUserID}`);
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },

    addOrganization: async (values) => {
        const formData = new FormData();
        formData.append('organization_name', values.organizationName);
        formData.append('phone', values.phone);
        formData.append('email', values.email);
        formData.append('profile_image', values.image);
        formData.append('first_name', values.name);
        formData.append('last_name', values.last_name);
        try {
            const response = await apiService.post('/addOrganization', formData);
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message || 'Failed to import preferred regions.');
        }
    },

    getDeletedOrganization: async (deleteId) => {
        try {
            const response = await apiService.delete(`/deleteOrganization/${deleteId}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    adminDeleteLeadRequest: async (deleteId) => {
        try {
            const response = await apiService.post(`adminDeleteLeadRequest`, { lead_id: deleteId });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },

    UpdateOrganization: async (values, updatedId) => {
        const formData = new FormData();
        formData.append('id', parseInt(updatedId, 10));
        formData.append('organization_name', values.OrganizationName);
        formData.append('phone', values.phone);
        formData.append('email', values.email);
        formData.append('profile_image', values.image);
        try {
            const response = await apiService.post('/updateOrganization', formData);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    GetAllCustomers: async (currentPage, searchTerm, searchParam, selectedFilterValue, selectedRefer) => {
        try {
            const { from_date, to_date } = searchParam;

            let queryParams = `?page=${currentPage}`;
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            if (from_date) {
                queryParams += `&from_date=${from_date}`;
            }

            if (to_date) {
                queryParams += `&to_date=${to_date}`;
            }
            if (selectedFilterValue) {
                queryParams += `&registered_by=${selectedFilterValue}`;
            }
            if (selectedRefer) {
                queryParams += `&refer_by=${selectedRefer}`;
            }

            const response = await apiService.get(`/getAllCustomers${queryParams}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    customerDetails: async (id) => {
        try {
            const response = await apiService.post(`getCustomerDetail`, { customer_id: id });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    UpdateCustomerProfile: async (values, customerId) => {
        const formData = new FormData();
        formData.append('customer_id', parseInt(customerId, 10));
        formData.append('name', values.name);
        formData.append('last_name', values.last_name);
        formData.append('phone', values.phone);
        formData.append('password', values.password);
        formData.append('profile_image', values.image);
        try {
            const response = await apiService.post('/updateCustomerProfile', formData);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getComplainsByAdmin: async (currentPage, searchTerm, searchParam) => {
        try {
            const { from_date, to_date } = searchParam;
            let queryParams = '';

            if (currentPage) {
                queryParams += `?page=${currentPage}`;
            }
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            if (from_date) {
                queryParams += `&from_date=${from_date}`;
            }

            if (to_date) {
                queryParams += `&to_date=${to_date}`;
            }

            const response = await apiService.get(`/getComplainsByAdmin${queryParams}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    updateComplainStatus: async (id, complaintMessage) => {
        try {
            const response = await apiService.post(`updateComplainStatus`, { id: id, message: complaintMessage });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },

    ICAGetStatusScoring: async () => {
        try {
            const response = await apiService.get(`/getStatusScoring`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getPreferedRegions: async () => {
        try {
            const response = await apiService.get(`/getPreferedRegions`);
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },
    updateIcaProfilePassword: async (currentPassword, newPassword, confirmPassword) => {
        try {
            // Ensure passwords are strings and not objects
            const oldPasswordStr = String(currentPassword);
            const newPasswordStr = String(newPassword);
            const confirmPasswordStr = String(confirmPassword);

            const response = await apiService.post('/changeICAAgentPassword', {
                old_password: oldPasswordStr,
                password: newPasswordStr,
                password_confirmation: confirmPasswordStr,
            });
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },
    getCancelInvitation: async (id) => {
        try {
            const response = await apiService.post(`/deleteLeadRequest`, { lead_id: id });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getIcaAllChat: async (LoginUserID) => {
        try {
            const response = await apiService.post(`/get-all-chat`, { id: LoginUserID });
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },

    getIcaAllChatDetails: async (leadId) => {
        try {
            const response = await apiService.post(`/lead-details`, { lead_id: leadId });
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },
    getICATodayLeads: async () => {
        try {
            const response = await apiService.get(`/getICATodayLeads`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getReferCode: async (currentPageRef, searchTermRefer, isPaginatedRef, allUsers) => {
        
        try {
            let queryParams = `?paginated=${isPaginatedRef}`;
            if (typeof allUsers === 'boolean') {
                queryParams += `&allUsers=${allUsers}`;
            }
            if (currentPageRef) {
                queryParams += `&page=${currentPageRef}`;
            }
            if (searchTermRefer) {
                queryParams += `&search=${searchTermRefer}`;
            }
            const response = await apiService.get(`/getUsersForFilter${queryParams}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    GetReferralAgentData: async (isPaginated,currentPage,searchTerm,allUsers,selectedUserType,selectedImportType) => {
        try {
            let queryParams = `?paginated=${isPaginated}`;
            if (typeof allUsers === 'boolean') {
                queryParams += `&allUsers=${allUsers}`;
            }
            if (currentPage) {
                queryParams += `&page=${currentPage}`;
            }
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            if (selectedUserType) {
                queryParams += `&user_type=${selectedUserType}`;
            }
            if (selectedImportType) {
                queryParams += `&import_type=${selectedImportType}`;
            }
            const response = await apiService.get(`/getUsersForFilter${queryParams}`);
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },
    GetShiftedOrganizationAgent: async (currentPage, searchTerm) => {
        try {
            let queryParams = `?page=${currentPage}`;
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            const response = await apiService.get(`/shiftedOrganizationAgent${queryParams}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    shiftedOrganizationAgentAssignments: async (id,currentPage) => {
        try {
            
            const response = await apiService.post(`/shiftedOrganizationAgentAssignments`, { id: id , page: currentPage});
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },
    getAllOrganizationAgent: async () => {
        try {
            const response = await apiService.get(`/getAllOrganizationAgent`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    assignLeadToNewAgent: async (id,selectedValue,SelectedLeadValue) => {
        try {
            const response = await apiService.post(`/assignLeadToNewAgent`, { id: id , agent_id: selectedValue, lead_ids : SelectedLeadValue});
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },
    AllPrompts: async (currentPage,PromptsType,sentStatus,userType) => {
        try {
            const response = await apiService.get('/getAllPrompts', {
                params: {
                    type: PromptsType,
                    page: currentPage,
                    status:sentStatus,
                    user_type:userType
                }
            });
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message || 'An error occurred while fetching prompts.');
        }
    },
    
    AddPromptMessage: async (createMessage, PromptType,userType) => {
        try {
            const response = await apiService.post('/createPromptNotification', {
                message: createMessage,
                type: PromptType,
                notification_for: userType
            });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    GetPromptMessage: async (promptID)=>{
        try{
            const response = await apiService.get(`/getPromptMessage/${promptID}`);
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },

    UpdatePromptNotification: async (selectedId,messageById, promptTypeById,userType) => {
        try {
            const response = await apiService.post('/updatePromptNotification', { id: selectedId, message: messageById, type: promptTypeById, notification_for:userType});
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    DeletePromptNotification:async(deletedId) =>{
        try{
            const response = await apiService.delete(`/deletePromptNotification/${deletedId}`);
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    UpdateTimeSetting: async (formattedMorningTime, formattedEveningTime, agentID, CustomerID) => {
        try {
            const settingID = agentID || CustomerID;
    
            if (!settingID) {
                throw new Error("Either agentID or CustomerID must be provided.");
            }
    
            const response = await apiService.post('/updateSettings', {
                morning_push_time: formattedMorningTime,
                afternoon_push_time: formattedEveningTime,
                setting_id: settingID
            });
    
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message || "An error occurred while updating settings.");
        }
    },
    
    GetCustomNotification: async (customType,searchTerm,OsDevice,SubscriptionDevice,appValue)=>{
        try{
            
            let queryParams = `?search=${searchTerm}`;
            if(customType){
                queryParams += `&user_type=${customType}`;
            }
            if(OsDevice){
                queryParams += `&device_os=${OsDevice}`;
            }
            if(SubscriptionDevice){
                queryParams += `&subscription_type=${SubscriptionDevice}`;
            }
            if(appValue){
                queryParams += `&app_version=${appValue}`;
            }
            const response = await apiService.get(`/getDeviceTokenUsers${queryParams}`);
            
            return response;
        }catch(error){
            throw new Error(error?.response?.data?.message)
        }
    },
    AddCustomNotification: async (createMessage,selectedUserIds) =>{
        try{
            const response = await apiService.post('/adminSendCustomNotifications', { message: createMessage, user_ids: selectedUserIds });
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    getPromptMessageSendTimes: async () => {
        try {
            const response = await apiService.get(`/getPromptMessageSendTimes`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getCustomerPromptMessageSendTimes: async () => {
        try {
            const response = await apiService.get(`/getCustomerPromptMessageSendTimes`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    CountAgentAndCustomer:async () =>{
        try{
            const response = await apiService.get('/countAgentAndCustomer');
            return response;
        }catch(error){
            throw new Error(error?.response?.data?.message);
        }
    },
    CountAgentAndCustomerOrgAdmin:async () =>{
        try{
            const response = await apiService.get('/countAgentAndCustomerOrgAdmin');
            return response;
        }catch(error){
            throw new Error(error?.response?.data?.message);
        }
    },
    DeleteAlerts:async(deletedId) =>{
        try{
            const response = await apiService.post(`/adminDeleteConfirmation`, { confirmation_id: deletedId });
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    adminDeletePenalty :async(deletedPenaltyId) =>{
        try{
            const response = await apiService.post(`/adminDeletePenalty`, { penalty_id: deletedPenaltyId });
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    initiateGroupCall:async(callType,leadId,caller_id,receiver_ids) =>{
        try{
            const response = await apiService.post(`/initiateGroupCall`, { type: callType, lead_id: leadId, caller_id, receiver_id: receiver_ids  });
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    getAllVersion:async(selectedForceValue,selectedFilterValue,selectedLive,searchTerm) =>{
        try{
            let queryParams = `?search=${searchTerm}`;
            if (selectedForceValue) {
                queryParams += `&hard_force=${selectedForceValue}`;
            }
            if (selectedFilterValue) {
                queryParams += `&platform=${selectedFilterValue}`;
            }
            if (selectedLive !== undefined && selectedLive !== null) {
                queryParams += `&is_live=${selectedLive}`;
            }
            const response = await apiService.get(`/getAllVersions${queryParams}`);
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    AddVersion:async(versionInputField,selectedFilterValue,selectedForceValue) =>{
        try{
            const response = await apiService.post(`/addVersion`, { version: versionInputField, platform: selectedFilterValue, force_update: selectedForceValue  });
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    GetVersionForEdit: async (selectedEditId) =>{
        try{
            const response = await apiService.get(`/getVersion?version_id=${selectedEditId}`);

            return response;
        }catch(error){
            throw new Error(error?.response?.data?.message);
        }
    },
    UpdateVersion: async (selectedEditId,versionInputField,selectedFilterValue,selectedForceValue) => {
        try {
            const response = await apiService.post('/updateVersion', { version_id:selectedEditId ,version:versionInputField ,platform: selectedFilterValue, force_update: selectedForceValue});
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    forcelyUpdateVersion: async (id, newStatus) => {
        try {
            const response = await apiService.post('/forcelyUpdateVersion', {version_id : id,  force_update: newStatus });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    deleteVersion: async (deleteId) => {
        try {
            const response = await apiService.delete(`/deleteVersion/${deleteId}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    GetOsAndroidSubscriptionTypeVersion: async () => {
        try {
            const response = await apiService.get(`/getAppVersions_DeviceOs_SubscriptionTypes`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getAgentSlots: async (agentId,formattedDate) => {
        try {
            const response = await apiService.post(`/getAgentSlots`, {agent_id :agentId , date:formattedDate });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    addTimeZone: async (GetOffSet) => {
        try {
            const response = await apiService.post(`/addTimeZone`, {offset :GetOffSet });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    makeVersionLive : async (id, newValue) => {
        try {
            const response = await apiService.post('/makeVersionLive ', {version_id : id,  is_live: newValue });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    GetIcaAlerts: async (selectedValue) =>{
        try{
            const response = await apiService.get(`/getAlerts?time=${selectedValue}`);
            return response;
        }
        catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    bridgeMatrix: async (formattedDate) =>{
        try{
            const response = await apiService.get(`/bridgeMatrix?yearMonth=${formattedDate}`);
            return response;
        }
        catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    changeAgentTrial: async (currentId, selectedDays) => {
        try {
            const response = await apiService.post(`/changeAgentTrial`, { agent_id: currentId,  days :selectedDays });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    AddTag: async (addTag, agent_id) => {
        try {
            const response = await apiService.post('/createAgentTag', {
                agent_id: agent_id,
                tag: addTag,
            });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    updateTag: async (editTagId,editTag) => {
        try {
            const response = await apiService.post('/updateAgentTag', {
                tag_id: editTagId,
                tag: editTag,
            });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    DeleteTag: async (deleteId, tagId) => {
        try {

            const response = await apiService.post(`/destroyAgentTag`, {agent_id: deleteId, tag_id:tagId});
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    HandleSwitchAgentCustomer: async (id, SwitchCustomer) => {
        try {
            const response = await apiService.post(`/changeUserType`, { user_id: id,  convert_type :SwitchCustomer });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    getTags: async () => {
        try {
            const response = await apiService.get(`/getTags`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    voipDeviceToken: async (token) => {
        try {
            const response = await apiService.post(`/ica-device-token` , { device_token :token });
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },
    showReferralUser: async (id) => {
        try {
            const response = await apiService.post(`/showReferralUser` , { referral_code :id });
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },
    checkAgentAvailability: async (receiver_id) => {
        try {
            const response = await apiService.post(`/checkAgentAvailability` , { receiver_id :receiver_id });
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },
    createAgentCustomer: async (receiverId) => {
        try {
            const response = await apiService.post(`/createAgentCustomer` , { receiver_id :receiverId});
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },
    deviceTokenFirebase: async (token) => {
        try {
            const response = await apiService.post(`/customer-device-token` , { device_token :token });
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message);
        }
    },
    initiateWebSingleCall:async(callType,receiver_id,caller_id,firstName,lastName,) =>{
        try{
            const response = await apiService.post(`/initiateWebSingleCall`, { type: callType, receiver_id: receiver_id ,caller_id:caller_id, first_name: lastName, last_name:firstName });
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    callerCallEnded:async(callerId,id) =>{
        try{
            const response = await apiService.post(`/callerCallEnded`, { login_userId: callerId, call_id: id });
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    isReceiverAccepted:async(call_id,receiver_id) =>{
        try{
            const response = await apiService.post(`/isReceiverAccepted`, { call_id,receiver_id });
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    updateCallLastActivity:async(call_id) =>{
        try{
            const response = await apiService.post(`/updateCallLastActivity`, {call_id: call_id });
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    IcaCreateContact: async (
        name,
        lastName,
        email,
        phone,
        leadSource,
        leadType,
        inputAddress,
        city,
        state,
        importFormState,
        zipCode,
        latitude,
        longitude
    ) => {
        try {
            const response = await apiService.post(`createContactICA`, {
                firstName: name,
                lastName: lastName,
                phone: phone,
                email: email,
                leadSource:leadSource,
                leadType: leadType,
                propertyAddress: inputAddress,
                propertyCity:city,
                propertyState:state,
                import_from:importFormState,
                propertyZipcode: zipCode,
                propertyLatitude: latitude,
                propertyLongitude: longitude

            });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    ImportLeadsFileICA: async (files,importFormState) => {
        const formData = new FormData();
        formData.append('csv_file', files);
        formData.append('import_from', importFormState);
        try {
            const response = await apiService.post('/importLeadsFileIca', formData);
            return response;
        } catch (error) {
            throw new Error(error?.response?.data?.message || 'Failed to import preferred regions.');
        }
    },
    GetUsersForSales:async(
        currentPage,
        searchTerm,
        selectedUserType,
        signal,
        fromDate = '', 
        toDate = '', 
    ) =>{
        try{
            let queryParams = `?page=${currentPage}`;
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            if (selectedUserType) {
                queryParams += `&user_type=${selectedUserType}`;
            }
            if (fromDate) {
                queryParams += `&from_date=${fromDate}`;
            }
            if (toDate) {
                queryParams += `&to_date=${toDate}`;
            }
            
            const response = await apiService.get(`/getUsersForSales${queryParams}`,);
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    GetUsersCheckSubscription:async(
        CheckID 
    ) =>{
        try{
            let queryParams = `?id=${CheckID}`;
            const response = await apiService.get(`/getUsersForSales${queryParams}`,);
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    GetUsersCheckSubscription:async(
        CheckID 
    ) =>{
        try{
            let queryParams = `?id=${CheckID}`;
            const response = await apiService.get(`/getUsersForSales${queryParams}`,);
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    GetReferralSalesUsers:async(searchTerm) =>{
        try{
            // let queryParams = `?current_page=${currentPage}`;
            // if (searchTerm) {
            //     queryParams += `&search=${searchTerm}`;
            // }
            const response = await apiService.get(`/salesGetReferralUsers?search=${searchTerm}`);
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    AdminReferralSalesUsers:async(searchTerm) =>{
        try{
            // let queryParams = `?current_page=${currentPage}`;
            // if (searchTerm) {
            //     queryParams += `&search=${searchTerm}`;
            // }
            const response = await apiService.get(`/adminGetReferralUsers?search=${searchTerm}`);
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    GetReferralSalesDetails:async(isPaginated,currentPage,searchTerm,id) =>{
        try{
            let queryParams = `?page=${currentPage}`;
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            if (isPaginated) {
                queryParams += `&paginated=${isPaginated}`;
            }
            const response = await apiService.post(`/referralDetailsBySales${queryParams}`,{ id: id });
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    AdminGetReferralSalesDetails:async(isPaginated,currentPage,searchTerm,id) =>{
        try{
            let queryParams = `?page=${currentPage}`;
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            if (isPaginated) {
                queryParams += `&paginated=${isPaginated}`;
            }
            const response = await apiService.post(`/referralDetailsByAdmin${queryParams}`,{ id: id });
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    sendSubscriptionNotification: async (subscriptionId) =>{
        try{
            const response = await apiService.post('/sendSubscriptionNotification',{agent_id: subscriptionId});
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    getSalesAgents: async (currentPage, searchTerm) => {
        try {
            let queryParams = `?page=${currentPage}`;
            if (searchTerm) {
                queryParams += `&search=${searchTerm}`;
            }
            const response = await apiService.get(`/getSalesAgents${queryParams}`);
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    createAgentBySales:async(updatedFormData) =>{
        try{
            const response = await apiService.post('/createAgentBySales',updatedFormData);
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    checkUserEmailIntelligence: async (email) =>{
        try{
            const response = await apiService.get(`/checkUserEmailIntelligence?search=${email}`);
            return response;
        }catch(error){
            throw new Error(error?.response.data?.message);
        }
    },
    sendCancelSubNotification : async (id) => {
        try {
            const response = await apiService.post(`sendCancelSubNotification`, {agent_id: id});
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
    GetUpdateIcaMeeting: async (leadMeetingId,newLatitude,newLongitude,newMeetingLocation,selectedDate,formattedSelectTime) => {
        try {
            const response = await apiService.post('/addTimeInLead', {
                lead_id: leadMeetingId,
                date: selectedDate,
                time: formattedSelectTime,
                meeting_location: newMeetingLocation,
                meeting_latitude: newLatitude,
                meeting_longitude: newLongitude,
            });
            return response;
        } catch (error) {
            throw new Error(error?.response.data?.message);
        }
    },
};
export default LeadService;
